//标签api
import request from '@/util/request'

//获取标签，可获取对象的标签
export function getTags(data,type){
	switch(String(type)){
		case "1":
			return request({
				url: `/maintain-s/station/${data}/tags`,
				method: 'get'
			});
			break;
		default:
			if(!data){
				data={
					"order.direction":"DESC",
					"order.property":"id",
					page:1,
					size:9999
				}
			}
			return request({
				url: `/tag-s/tag/list`,
				method: 'get',
				params: data
			})
			break;
	}
}

//添加标签
export function apiAddTag(data,typeList,des,id,type){//给对象或数据库添加标签
	// if($.type(data)!="array") data=[data];
	switch(String(type)){
		case "1":
			return request({
				url: `/maintain-s/station/${id}/tags`,
				method: 'post',
				data
			});
			break;
		default://全局添加标签
			return request({
				url: `/tag-s/tag`,
				method: 'post',
				data:{
					name:data,
					adaptObjectTypeList:typeList,
					description:des//||data
				}
			});
			break;
	}
}

//删除标签
export function apiDeleteTag(data,type,id){
	if($.type(data)!="array") data=[data];
	switch(String(type)){
		case "1"://运营部分
			return request({
				url: `/maintain-s/station/${id}/tags`,
				method: 'delete',
				data
			});
			break;
		default:
			return request({
				url: `/tag-s/tag/batch`,
				method: 'delete',
				data
			})
			break;
	}
}

//更新对象的标签
export function apiUpdateTag(data=[],id,type){
	switch(String(type)){
		case "1":
			return request({
				url: `/maintain-s/station/${id}/tags`,
				method: 'post',
				data
			});
			break;
		default:
			return request({
				url: `/tag-s/tag/${id}`,
				method: 'post',
				data
			})
			break;
	}
}

export function apiAddTagBatch(data = {}){
	return request({
		url: `/maintain-s/station/tags`,
		method: 'post',
		data
	})
}




// WEBPACK FOOTER //
// ./src/api/manage/tag.js